import { api } from '@verifime/api-definition';
import { ZodiosHooks } from '@zodios/react';

// We'd like to export react hooksApi from this shared views package
export const hooksApi = new ZodiosHooks('personApi', api);
